/** First-party paths so adblock cosmetic filters on social hrefs do not hide our links. */

export const OUTBOUND = {
	li: 'https://www.linkedin.com/company/brave.generation',
	ig: 'https://www.instagram.com/brave.generation.ua/',
	x: 'https://twitter.com/BraveGenUkraine'
} as const;

export type OutboundSlug = keyof typeof OUTBOUND;

const ALLOWED_HOSTS = new Set([
	'www.instagram.com',
	'instagram.com',
	'www.linkedin.com',
	'linkedin.com',
	'twitter.com',
	'www.twitter.com',
	'x.com',
	'www.x.com'
]);

export function outboundPath(slug: OutboundSlug): string {
	return `/go/${slug}`;
}

/** Wrap an allowlisted absolute URL in a same-origin redirect. */
export function outboundUrl(absoluteUrl: string): string {
	return `/go/out?u=${encodeURIComponent(absoluteUrl)}`;
}

export function resolveOutboundSlug(slug: string | undefined): string | null {
	if (!slug) return null;
	if (slug in OUTBOUND) return OUTBOUND[slug as OutboundSlug];
	return null;
}

export function resolveOutboundTarget(raw: string | null): string | null {
	if (!raw) return null;
	try {
		const parsed = new URL(raw);
		if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') return null;
		if (!ALLOWED_HOSTS.has(parsed.hostname)) return null;
		return parsed.toString();
	} catch {
		return null;
	}
}
